import Loading from '../../../Common/Loading';
import { usePreviousPregnanciesChartsDataContext } from './hooks/usePreviousPregnanciesChartsDataContext';
import { Indicators } from './Indicators';
import { PreviousBirthTypes } from './PreviousBirthTypes';
import { PreviousPregnanciesQuantityDeathBirths } from './PreviousPregnanciesQuantityDeathBirths';
import { PreviousPregnanciesQuantityLiveBirths } from './PreviousPregnanciesQuantityLiveBirths';
import { PreviousPregnancies } from './PreviousPregnancies';

export const Charts = () => {
    const { isLoading } = usePreviousPregnanciesChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <Indicators />
            <div className="w-100">
                <PreviousPregnancies/>
            </div>
            <div className="charts-side-by-side-dashboards">
                <PreviousPregnanciesQuantityDeathBirths />
                <PreviousBirthTypes />
            </div>
            <div className="w-100">
                <PreviousPregnanciesQuantityLiveBirths />
            </div>
           
        </>
    );
};
